import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum ChangeType {
	DECREASE = 1,
	INCREASE = 2
}

export namespace ChangeType {

	export function getTitle(type: ChangeType): string {
		return Object.keys(ChangeType).find(key => ChangeType[key] === type);
	}

}

@Pipe({
	name: 'changeTypeText',
	standalone: true
})
export class ChangeTypeTextPipe implements PipeTransform {

	changeType = ChangeType;
	translatedText: string;
	constructor(private translateService: TranslateService) {
	}


	transform(value: ChangeType): any {
		this.getTranslate(
			this.changeType.getTitle(value)
		);
		return this.translatedText;
	}


	async getTranslate(text: string) {
		text = 'ENUM.CHANGE_TYPE.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}



